/* eslint-disable import/prefer-default-export */
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { getFreightModesConfig } from "api/services/location";
import { GetFreightModesConfigResponseType } from "api/response";
import { locationQueryKeys } from "./locationQueryKeys";

export function useGetFreightModesConfig(
  location: string,
  options?: UseQueryOptions<GetFreightModesConfigResponseType, unknown>,
): UseQueryResult<GetFreightModesConfigResponseType> {
  const func = async (): Promise<GetFreightModesConfigResponseType> => {
    const response = await getFreightModesConfig(location);
    return response.data;
  };

  return useQuery<GetFreightModesConfigResponseType, unknown>({
    queryKey: locationQueryKeys.freightModesConfig(location),
    queryFn: func,
    enabled: !!location,
    ...options,
  });
}
